import { Fancybox } from '@fancyapps/ui'

/**
 * Products filter
 * - category tabs → URL param ?cat=slug
 * - "only free" checkbox → URL param ?free=1
 * - state restored from URL on page load
 */

class Products {
    constructor() {
        this.table = document.querySelector('.js-products-table')
        if (!this.table) return

        this.rows        = [...this.table.querySelectorAll('.js-products-row')]
        this.filterBtns  = [...document.querySelectorAll('.js-products-filter')]
        this.checkbox    = document.querySelector('#js-products-free')
        this.empty       = document.querySelector('.products__empty')
        this.inquiryModal = document.querySelector('#inquiry-modal')

        const params      = new URLSearchParams(window.location.search)
        const defaultCat  = this.filterBtns[0]?.dataset.cat || ''
        this.state = {
            cat:  params.get('cat') || defaultCat,
            free: params.get('free') === '1',
            type: params.get('dispozice') || '',
        }

        this.init()
    }

    init() {
        this.filterBtns.forEach(btn => {
            btn.classList.toggle('is-active', btn.dataset.cat === this.state.cat)
            btn.addEventListener('click', this.handleCat)
        })

        if (this.checkbox) {
            this.checkbox.checked = this.state.free
            this.checkbox.addEventListener('change', this.handleFree)
        }

        this.applyFilter()
        this.initTypeFilter()
        this.initInquiry()
        this.initDetailModal()
    }

    initInquiry() {
        if (!this.inquiryModal) return

        // mousedown fires before fancybox click — values are ready when lightbox opens
        document.addEventListener('mousedown', e => {
            const btn = e.target.closest('.js-products-order')
            if (!btn) return

            const aptName  = btn.dataset.aptName || ''
            const titleEl  = this.inquiryModal.querySelector('.js-inquiry-title')
            const hiddenEl = this.inquiryModal.querySelector('.js-inquiry-apt')

            if (titleEl) {
                if (!titleEl.dataset.base) titleEl.dataset.base = titleEl.textContent
                titleEl.textContent = aptName
                    ? titleEl.dataset.base + '  •  ' + aptName
                    : titleEl.dataset.base
            }
            if (hiddenEl) hiddenEl.value = aptName

            const msgEl = this.inquiryModal.querySelector('.js-inquiry-message')
            if (msgEl && msgEl.dataset.template) {
                const unitType = btn.dataset.aptUnitType || 'bytové jednotky'
                msgEl.value = msgEl.dataset.template
                    .replace('{unit_type}', unitType)
                    .replace('{apt}', aptName)
            }
        })

        document.addEventListener('click', e => {
            const btn = e.target.closest('.js-products-order')
            if (!btn) return
            e.preventDefault()

            Fancybox.show([{ src: '#inquiry-modal', type: 'inline' }])
        })
    }

    normalize(s) {
        return (s || '').toLowerCase().replace(/[+\s]/g, '')
    }

    initTypeFilter() {
        this.typeFilterRow   = this.table.querySelector('.js-type-filter-row')
        this.typeFilterLabel = this.table.querySelector('.js-type-filter-label')
        const clearBtn       = this.table.querySelector('.js-type-filter-clear')

        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                this.state.type = ''
                this.updateUrl()
                this.syncTypeFilter()
                this.applyFilter()
            })
        }

        this.syncTypeFilter()
    }

    syncTypeFilter() {
        if (!this.typeFilterRow) return
        this.typeFilterRow.hidden = !this.state.type
        if (this.state.type && this.typeFilterLabel) {
            this.typeFilterLabel.textContent = this.state.type
        }
    }

    initDetailModal() {
        document.addEventListener('click', e => {
            const preview = e.target.closest('.js-modal-preview')
            if (preview) {
                const modal   = preview.closest('.modal-detail')
                const flipped = !preview.classList.contains('is-flipped')
                this.setModalState(modal, flipped)
                return
            }

            const tab = e.target.closest('.js-modal-tab')
            if (tab) {
                const modal = tab.closest('.modal-detail')
                this.setModalState(modal, tab.dataset.state === 'b')
            }
        })
    }

    setModalState(modal, flipped) {
        const preview = modal?.querySelector('.js-modal-preview')
        const mainImg = modal?.querySelector('.js-modal-main-img')
        const tabs    = modal?.querySelectorAll('.js-modal-tab')

        if (!preview) return

        const srcA = preview.dataset.srcA
        const srcB = preview.dataset.srcB

        preview.classList.toggle('is-flipped', flipped)
        if (mainImg) mainImg.src = flipped ? srcB : srcA

        const thumb = preview.querySelector('img')
        const label = preview.querySelector('span')
        if (thumb) thumb.src         = flipped ? srcA : srcB
        if (label) label.textContent = flipped ? preview.dataset.labelA : preview.dataset.labelB

        tabs?.forEach(tab =>
            tab.classList.toggle('is-active', tab.dataset.state === (flipped ? 'b' : 'a'))
        )
    }

    handleCat = e => {
        this.state.cat = e.currentTarget.dataset.cat
        this.filterBtns.forEach(btn =>
            btn.classList.toggle('is-active', btn.dataset.cat === this.state.cat)
        )
        this.updateUrl()
        this.applyFilter()
    }

    handleFree = e => {
        this.state.free = e.currentTarget.checked
        this.updateUrl()
        this.applyFilter()
    }

    applyFilter() {
        let visible = 0

        this.rows.forEach(row => {
            const cats   = row.dataset.cats ? row.dataset.cats.split(' ') : []
            const status = row.dataset.status

            const catOk  = !this.state.cat || cats.includes(this.state.cat)
            const freeOk = !this.state.free || status === 'volny'
            const typeOk = !this.state.type || this.normalize(row.dataset.type) === this.normalize(this.state.type)
            const show   = catOk && freeOk && typeOk

            row.style.display = show ? '' : 'none'
            if (show) visible++
        })

        const isEmpty = visible === 0
        if (this.empty)  this.empty.hidden  = !isEmpty
        this.table.hidden = isEmpty
    }

    updateUrl() {
        const params = new URLSearchParams(window.location.search)

        this.state.cat  ? params.set('cat', this.state.cat)       : params.delete('cat')
        this.state.free ? params.set('free', '1')                 : params.delete('free')
        this.state.type ? params.set('dispozice', this.state.type) : params.delete('dispozice')

        const qs = params.toString()
        history.replaceState(null, '', qs ? `?${qs}` : window.location.pathname)
    }
}

new Products()
